export const STATION_QUERY_KEYS = {
  GET_STATIONS: 'GET_STATIONS',
  GET_STATION: 'GET_STATION',
} as const
